var Dashboard = {

	init: function() {
		Dashboard.accordionFaq();
	},

	accordionFaq: function() {
		$('#accordionFAQ button').click(function () {
			$('.card').removeClass('active');
			
			var expanded = $(this).attr('aria-expanded');
			if(expanded == "false") {
				$(this).parents('.card').addClass('active');
			}
			else {
				
			}
		})
	}
}